"use client";

import Link from "next/link";
import { Typography, Card, Tag, Button, Space } from "antd";
import { SiteHeader, SiteFooter } from "@/widgets/site-layout";

const { Title, Paragraph, Text } = Typography;

const examples = [
  {
    title: "Годовой отчёт",
    desc: "Финансовые таблицы открываются в модальных окнах, графики — в полноэкранном режиме.",
    tags: ["Таблицы", "Изображения", "Сноски"],
  },
  {
    title: "Регламент компании",
    desc: "Структурированное оглавление, поиск по тексту, ссылки на внешние ресурсы.",
    tags: ["Оглавление", "Поиск", "Ссылки"],
  },
  {
    title: "Техническая документация",
    desc: "Вложения PDF и схемы доступны одним кликом, сноски с пояснениями.",
    tags: ["Вложения", "Сноски", "Модальные окна"],
  },
];

export default function ExamplesPage() {
  return (
    <>
      <SiteHeader />
      <main style={{ padding: "64px 24px", background: "#f5f5f5", flex: 1 }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          <Title level={1} style={{ textAlign: "center" }}>Примеры</Title>
          <Paragraph type="secondary" style={{ textAlign: "center", marginTop: 16 }}>
            Посмотрите, как выглядят интерактивные документы
          </Paragraph>
          <Space direction="vertical" size="large" style={{ width: "100%", marginTop: 48 }}>
            {examples.map((ex) => (
              <Card key={ex.title}>
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                  <div style={{ flex: 1 }}>
                    <Title level={4}>{ex.title}</Title>
                    <Paragraph type="secondary">{ex.desc}</Paragraph>
                    <Space wrap style={{ marginTop: 8 }}>
                      {ex.tags.map((tag) => (
                        <Tag key={tag} color="blue">{tag}</Tag>
                      ))}
                    </Space>
                  </div>
                  <div
                    style={{
                      height: 128,
                      minWidth: 192,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 8,
                      background: "#f5f5f5",
                      border: "1px solid #f0f0f0",
                    }}
                  >
                    <span style={{ fontSize: 48, opacity: 0.5 }}>📑</span>
                  </div>
                </div>
              </Card>
            ))}
          </Space>
          <div style={{ textAlign: "center", marginTop: 48 }}>
            <Link href="/admin/login">
              <Button type="primary" size="large">
                Попробовать на своём документе
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
